import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="17534" id="hero" className="relative flex min-h-[60vh] w-full items-center justify-center overflow-hidden bg-[#F8F8F6] text-[#1A1A2E]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/facility_soft_focus.png)] bg-cover bg-center bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-[#E2E8F0]/30 backdrop-blur-[2px]" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-[#F8F8F6]/80 via-[#F8F8F6]/40 to-[#F8F8F6]/90" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5")}>
        <div className="mx-auto max-w-4xl">
          <h1 className="mb-4 text-4xl font-bold tracking-tight text-[#1A1A2E] md:text-5xl lg:text-6xl font-serif">
            Bodywerks Blog
          </h1>
          <h2 className="mb-6 text-2xl font-medium tracking-tight text-[#4A5568] md:text-3xl font-serif">
            Restoring Balance, Enhancing Life
          </h2>
          
          <p className="mb-10 text-lg text-[#4A5568] md:text-xl leading-relaxed max-w-2xl mx-auto font-sans">
            Discover a holistic approach to wellness with expert chiropractic care in the heart of Cyprus. Experience professional therapy designed to restore movement and vitality.
          </p>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="https://bodywerks.chiroflow.cloud/book">
              <Button size="lg" className="h-12 px-8 text-base shadow-lg hover:scale-105 transition-all rounded-lg bg-[#3B8FD4] text-white">
                Book Now
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}